import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import SvgClose from '../../../../play-core/icons/Close';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { imagesBasePath } from '../../../../play-core/utils/base-path';
import { useVideoConfig } from '../../config/VideoAppContext';
import { Button } from '../ClickableComponents/Button';
import { colorSets } from '../ClickableComponents/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const imageResolution = '96x96';
export const AndroidPromotionBanner = ({
  androidBanner
}) => {
  const {
    t
  } = useTranslation();
  const {
    businessUnit
  } = useVideoConfig();
  const imageSource = `${imagesBasePath}/appIcons/${businessUnit}/play-${businessUnit}_${imageResolution}.png`;
  return /*#__PURE__*/_jsxs(AndroidAppLayout, {
    children: [androidBanner.onClose && /*#__PURE__*/_jsx(Close, {
      type: "icon",
      ariaLabel: t('global.close'),
      iconSize: 16,
      icon: /*#__PURE__*/_jsx(SvgClose, {}),
      onClick: androidBanner.onClose,
      colorSet: {
        ...colorSets.transparent,
        iconColor: Colors.SRF_b9b7ac
      }
    }), /*#__PURE__*/_jsx(PlayAppImage, {
      src: imageSource,
      alt: "play app"
    }), /*#__PURE__*/_jsxs(AppInformation, {
      children: [/*#__PURE__*/_jsxs(AppTitle, {
        children: ["Play ", businessUnit.toUpperCase(), " App"]
      }), /*#__PURE__*/_jsx(AppDescription, {
        children: androidBanner.descriptionText
      })]
    }), /*#__PURE__*/_jsx(AppLink, {
      href: androidBanner.link,
      children: androidBanner.text
    })]
  });
};
const Close = styled(Button).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "AndroidPromotionBanner__Close",
  componentId: "sc-ji28he-0"
})(["align-self:center;padding-right:8px;padding-left:8px;margin-left:-16px;"]);
const AndroidAppLayout = styled.div.withConfig({
  displayName: "AndroidPromotionBanner__AndroidAppLayout",
  componentId: "sc-ji28he-1"
})(["top:0;background-color:", ";display:flex;padding:8px 16px;height:52px;align-items:center;"], Colors.SRF_2E2D29);
const AppLink = styled.a.withConfig({
  displayName: "AndroidPromotionBanner__AppLink",
  componentId: "sc-ji28he-2"
})(["background:linear-gradient(90deg,", " 0%,", " 100%);box-shadow:0 0 2px rgba(0,0,0,0.08),0 1px 2px rgba(0,0,0,0.16);border-radius:18px;color:", ";", ";height:28px;padding:4px 12px;display:flex;align-items:center;"], Colors.SRF_e31f2b, Colors.SRF_c91024, Colors.WHITE, Fonts.regular(16));
const AppTitle = styled.span.withConfig({
  displayName: "AndroidPromotionBanner__AppTitle",
  componentId: "sc-ji28he-3"
})(["color:", ";", ""], Colors.SRF_fafaf8, Fonts.medium(18));
const AppDescription = styled.span.withConfig({
  displayName: "AndroidPromotionBanner__AppDescription",
  componentId: "sc-ji28he-4"
})(["color:", ";", ""], Colors.SRF_b9b7ac, Fonts.regular(14));
const PlayAppImage = styled.img.withConfig({
  displayName: "AndroidPromotionBanner__PlayAppImage",
  componentId: "sc-ji28he-5"
})(["object-fit:contain;border-radius:8px;height:36px;width:36px;"]);
const AppInformation = styled.div.withConfig({
  displayName: "AndroidPromotionBanner__AppInformation",
  componentId: "sc-ji28he-6"
})(["display:grid;margin-right:auto;margin-left:8px;"]);